import { apiSlice } from "../../app/api/apiSlice";

export const dashboardApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardStats: builder.query({
      query: () => "/dashboard/stats",
    }),
    searchGlobal: builder.query({
      query: (q) => ({
        url: "/search",
        params: { q },
      }),
    }),
  }),
});

export const { useGetDashboardStatsQuery, useSearchGlobalQuery } =
  dashboardApiSlice;
